import axios, { AxiosError } from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';
import { APP_CONFIG } from '../../config/appConfig';

const PORTAL_TOKEN_KEY = 'portal_access_token';

export const getPortalToken = (): string | null =>
  typeof window !== 'undefined' ? localStorage.getItem(PORTAL_TOKEN_KEY) : null;

export const setPortalToken = (token: string): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(PORTAL_TOKEN_KEY, token);
  }
};

export const clearPortalToken = (): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(PORTAL_TOKEN_KEY);
  }
};

const portalApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  timeout: APP_CONFIG.api.timeout,
});

portalApi.interceptors.request.use(
  (config) => {
    const token = getPortalToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

portalApi.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const status = error.response?.status;
    if (status === 401) {
      clearPortalToken();
      const isPortalLogin = window.location.pathname === '/portal/login';
      if (!isPortalLogin) {
        window.location.href = '/portal/login';
      }
    }
    return Promise.reject(error);
  }
);

export default portalApi;
